import './vendor/tabs/skinable_tabs.js';

jQuery('.tabs_holder').skinableTabs({
  effect: 'basic_display',
  skin: 'skin7',
  position: 'top'
});